import { makeStyles } from '@material-ui/styles';

const expiredLinkErrorStyles = makeStyles({
  boxText: {
    maxWidth: '442px',
    margin: '24px auto 40px auto',
    '& p': {
      fontSize: '22px',
    },
  },
  boxIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export { expiredLinkErrorStyles };
